/**
 * 매장 가격 요청 줄의 [반영] → 가격 조회 화면을 그 카드에 맞춰 연다(코덱 리뷰 #869, 감사 card-controltower#869).
 * 앱은 라우터 없이 사이드바 state 로 화면을 바꾸므로, 여는 쪽이 한 번짜리 힌트(sessionStorage)를 남기고 가격 조회가 처음 그릴 때
 * 읽고 지운다(syncLogLink · storePrice:openTab 과 같은 방식). 저장소를 못 쓰면 가격 조회는 평소처럼 연다.
 */
export const PRICE_LOOKUP_FOCUS_KEY = 'priceLookup:focusCard';

export interface PriceLookupFocus {
  /** CT 카드 id. */
  cardId: number;
  /** 상품코드 — 안내 문구 · 카드를 못 찾았을 때 보인다. */
  code:   string;
  /** 상품 이름(모르면 상품코드). */
  name:   string;
}

export function writePriceLookupFocus(f: PriceLookupFocus): void {
  try {
    sessionStorage.setItem(PRICE_LOOKUP_FOCUS_KEY, JSON.stringify(f));
  } catch {
    // 저장소 없음 — 가격 조회는 평소처럼 연다.
  }
}

/** 읽기만 한다(렌더 중에 불러도 되게 — 지우기는 clearPriceLookupFocus 로 마운트 뒤에). 모양이 다르면 없음. */
export function readPriceLookupFocus(): PriceLookupFocus | null {
  try {
    const raw = sessionStorage.getItem(PRICE_LOOKUP_FOCUS_KEY);
    if (raw == null) return null;
    const v = JSON.parse(raw) as Partial<PriceLookupFocus> | null;
    if (!v || typeof v.cardId !== 'number' || !Number.isFinite(v.cardId)) return null;
    const code = typeof v.code === 'string' ? v.code : '';
    return { cardId: v.cardId, code, name: typeof v.name === 'string' && v.name !== '' ? v.name : code };
  } catch {
    return null;
  }
}

export function clearPriceLookupFocus(): void {
  try {
    sessionStorage.removeItem(PRICE_LOOKUP_FOCUS_KEY);
  } catch {
    // 저장소 없음
  }
}
